import { Modal } from "antd";
import React, { useCallback, useEffect } from "react";
import styles from "./SpotlightrVideoModal.module.css";
import classNames from "classnames";
import { IUserTrainingCourseVideoSummary } from "src/@types/ImpiricaPlatformApi";
import useScript from "react-script-hook";

type SpotlightrVideoModalProps = {
	video: IUserTrainingCourseVideoSummary;
	onClose: (videoId: string) => void;
	/** The player reached the end and has been asked to save the view to Spotlightr. */
	onEnded: (videoId: string) => void;
};

const SpotlightrVideoModal: React.FC<SpotlightrVideoModalProps> = ({
	video,
	onClose,
	onEnded,
}) => {
	const { id: videoId } = video;
	const [scriptLoading] = useScript({
		src: "https://training.impirica.tech/assets/spotlightr.js",
	});

	const _vooPlayerReady = useCallback(
		(event: any) => {
			console.log("vooPlayerReady", event.detail);
			// No "play" here: an external play before the first start makes the player mute itself, and "volume"
			// cannot undo it, so the learner's own click starts the video with sound.
			window.spotlightrAPI(videoId, "onEnded", null, () => {
				if (!videoId) return;
				// the player otherwise saves the view only on unload or its 5-minute timer
				window.spotlightrAPI(videoId, "sendVideoAnalytics");
				onEnded(videoId);
			});
		},
		[videoId, onEnded]
	);

	useEffect(() => {
		if (scriptLoading) return;

		document.addEventListener("vooPlayerReady", _vooPlayerReady);
		return () => {
			document.removeEventListener("vooPlayerReady", _vooPlayerReady);
		};
	}, [scriptLoading, _vooPlayerReady]);

	const close = useCallback(() => {
		if (videoId) {
			onClose(videoId);
		}
	}, [videoId, onClose]);

	return (
		<Modal
			visible={!!video}
			closable
			onCancel={close}
			footer={null}
			title={video.name}
			width={896}
		>
			<div className={styles.video} data-testid="video-content">
				<iframe
					allow="autoplay"
					className={classNames(
						"video-player-container",
						"videoPlayer",
						styles.videoFrame
					)}
					data-playerid={video.id}
					name="videoPlayerframe"
					allowFullScreen
					src={video.videoUrl}
					watch-type=""
					url-params=""
				>
					{" "}
				</iframe>
			</div>
		</Modal>
	);
};

export default SpotlightrVideoModal;
